import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const InputGroup = (props) => {
    return React.createElement(InputGroupStyled, { ...props });
};
export default InputGroup;
const InputGroupStyled = styled.div `
  display: inline-block;
  background-color: #ddd;
  border: 1px solid rgba(204, 204, 204, 1);
  margin-bottom: ${THEME.GRID_SPACING}px;
  border-radius: 3px;

  .btn,
  .iris-input-container {
    border-radius: 0;
    float: left;

    input {
      margin: -1px 1px;
    }
    &:last-child {
      input {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
    }
  }

  label.checkbox-wrapper {
    margin-bottom: 0px;
    margin: 4px 7px 4px 8px;

    input[type='checkbox'] {
      border: 1px solid rgba(204, 204, 204, 1);
    }
  }
`;
//# sourceMappingURL=InputGroup.js.map